import { MarketingClientSWFBase } from "./marketing-client-swf-base";
import { Utilization } from "./marketing-client-utilization";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { EventType } from "./constants/event-type-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { LayerType } from "./helpers/swf-helper";

export class MarketingClientShareArticleOld extends MarketingClientSWFBase {
  shareArticleInfoBtn = ".share-article-info-btn";
  wyborczaHat = "#wyborczaHat";

  constructor(utilizationObject: Utilization) {
    super(utilizationObject);
  }

  init() {
    this.initialize();
    this.bindEvents();
  }

  bindEvents() {
    this.bindEventsToModals();
    this.bindEventsToFormSubmit();
    this.bindEventsToEmailInput();
  }

  bindEventsToModals() {
    if (!this.form) return;

    DOMHelper.querySelector(this.shareArticleInfoBtn)?.addEventListener(EventType.CLICK, () => {
      if (this.form) {
        this.form.reset();
      }

      this.errorHandler.hide();
      this.showLayer(LayerType.DEFAULT);
    });
  }

  showLayer(layer = LayerType.DEFAULT, withScrollingOnMobile = false) {
    Object.values<HTMLElement>(this.layers).forEach((modal) =>
      modal.classList.add(MarketingClientConstants.hiddenClassName)
    );

    this.layers[layer]?.classList.remove(MarketingClientConstants.hiddenClassName);

    if (withScrollingOnMobile && this.isMobile) {
      this.scrollToLayer(this.layers[layer]);
    }
  }

  successResponseHandler(response: any) {
    if (response.status) {
      this.showLayer(LayerType.SUCCESS, true);
    } else if (response.result === LayerType.BLOCKED.toUpperCase()) {
      this.showLayer(LayerType.BLOCKED, true);
    } else {
      this.showLayer(LayerType.ERROR, true);
    }
  }

  errorResponseHandler() {
    this.showLayer(LayerType.ERROR, true);
  }

  scrollToLayer(layer: HTMLElement) {
    let cap: HTMLElement;
    cap = DOMHelper.getElementById(this.wyborczaHat) as HTMLElement;

    const capHeight = cap?.offsetHeight || 0,
      layerTop = layer.offsetTop,
      scrollTop = window.scrollY + capHeight;

    if (layerTop < scrollTop) {
      window.scrollTo({
        top: layerTop - capHeight - 20,
        behavior: "smooth"
      });
    }
  }
}
